import 'styles/pages/industry/it.scss';
import '~scripts/main';

// Packages
import Vue from 'vue';
import eases from 'eases';

// Swiper
import Swiper from 'swiper';
import { EffectFade, Navigation as SwiperNavigation, Pagination as SwiperPagination } from 'swiper/modules';
Swiper.use([EffectFade, SwiperNavigation, SwiperPagination]);

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import ClientsLogotypes from '~scripts/blocks/vue/ClientsLogotypes.vue';
import initRequestForm from '~scripts/blocks/request-form';

// Components
import '~scripts/components/modals';

// Breakpoints
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);
const mediaMd = window.matchMedia(`(min-width: ${BREAKPOINTS.mdMin})`);
const mediaLg = window.matchMedia(`(min-width: ${BREAKPOINTS.lgMin})`);

// Variables
const region = window.region;
const windowHeight = window.innerHeight;

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// CLIENTS
//
new Vue({
  el: '#VClientsLogotypes',
  name: 'VClientsLogotypes',
  components: {
    ClientsLogotypes,
  },
});

//
// PARTICIPANTS CASES
//
const participantsCases = document.getElementById('participantsCases');

// Animation
const handleParticipantsCasesAnimation = () => {
  return scrollAnimationProgress(participantsCases, {
    getStart(el) {
      const rect = el.getBoundingClientRect();
      return rect.top + window.scrollY - window.innerHeight;
    },
    getEnd(el, start) {
      const height = el.offsetHeight;
      if (window.matchMedia(`(max-width: ${BREAKPOINTS.lgMin})`).matches) {
        return start + height;
      } else {
        const height = el.offsetHeight;
        return start + windowHeight + height;
      }
    },
  });
};

handleParticipantsCasesAnimation();
mediaSm.addEventListener('change', handleParticipantsCasesAnimation);

// Slider
const participantsCasesSwiperOn = {
  beforeInit: function (swiper) {
    const swiperEl = swiper.$el[0];
    const swiperButtonPrev = swiperEl.querySelector('.swiper-button-prev');

    if (swiper.realIndex === 0) {
      swiperButtonPrev.style.opacity = 0;
    }
  },
  realIndexChange: function (swiper) {
    const swiperEl = swiper.$el[0];
    const swiperButtonPrev = swiperEl.querySelector('.swiper-button-prev');

    if (swiper.realIndex === 0) {
      swiperButtonPrev.style.opacity = 0;
    } else {
      swiperButtonPrev.style.opacity = 1;
    }
  },
};

const participantsCasesSliderOptionsBase = {
  effect: 'slide',
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};
const participantsCasesSliderOptionsSm = {
  allowTouchMove: true,
  navigation: false,
  noSwiping: false,
  preventClicks: true,
  preventClicksPropagation: true,
  slidesPerGroup: 1,
  slidesPerView: 'auto',
  spaceBetween: 12,
};
const participantsCasesSliderOptionsMd = {
  allowTouchMove: true,
  navigation: false,
  noSwiping: false,
  preventClicks: true,
  preventClicksPropagation: true,
  slidesPerGroup: 2,
  slidesPerView: 'auto',
  spaceBetween: 12,
};
const participantsCasesSliderOptionsLg = {
  allowTouchMove: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  noSwiping: true,
  preventClicks: false,
  preventClicksPropagation: false,
  slidesPerGroup: 2,
  slidesPerView: 'auto',
  spaceBetween: 20,
  on: participantsCasesSwiperOn,
};

const participantsCasesSliders = [];

const handleParticipantsCasesSliderInit = () => {
  if (participantsCasesSliders.length) {
    participantsCasesSliders.forEach((participantsCaseSlider) => {
      if (participantsCaseSlider) {
        participantsCaseSlider.destroy();
      }
    });
  }

  const quantityToInitSlider = mediaSm.matches ? 2 : 5;

  const participantsCasesSliderOptionsMedia = mediaSm.matches
    ? participantsCasesSliderOptionsSm
    : mediaMd.matches
      ? participantsCasesSliderOptionsMd
      : mediaLg.matches
        ? participantsCasesSliderOptionsLg
        : {};
  const participantsCasesSliderOptions = Object.assign(
    participantsCasesSliderOptionsBase,
    participantsCasesSliderOptionsMedia
  );

  const participantsCasesRow = document.getElementById('participantsRow') || null;
  const participantsCasesItems = participantsCases.querySelectorAll('.js-participants-item');
  const participantsCasesQuantity = participantsCasesItems.length;

  if (participantsCasesQuantity >= quantityToInitSlider) {
    if (participantsCasesRow) {
      participantsCasesRow.classList.add('swiper-wrapper');
    }

    participantsCasesItems.forEach((participantsCaseItem) => {
      participantsCaseItem.classList.add('swiper-slide');
    });

    const participantsCasesSlider = new Swiper(participantsCases, participantsCasesSliderOptions);

    participantsCasesSliders.push(participantsCasesSlider);
  } else {
    if (participantsCasesRow) {
      participantsCasesRow.classList.remove('swiper-wrapper');
    }

    participantsCasesItems.forEach((participantsCaseItem) => {
      participantsCaseItem.classList.remove('swiper-slide');
    });
  }
};

handleParticipantsCasesSliderInit();

mediaSm.addEventListener('change', handleParticipantsCasesSliderInit);
mediaMd.addEventListener('change', handleParticipantsCasesSliderInit);
mediaLg.addEventListener('change', handleParticipantsCasesSliderInit);

//
// TASK ITEM
//
// Animation
const taskItems = document.querySelectorAll('.js-tasks-list > li');

taskItems.forEach((taskItem) => {
  scrollAnimationProgress(
    taskItem,
    {
      getStart(el) {
        const rect = el.getBoundingClientRect();
        const height = el.offsetHeight;
        return rect.top + window.scrollY - (window.innerHeight + 80 - height / 2);
      },
      getEnd(el, start) {
        const height = el.offsetHeight;
        return start + height * 4;
      },
    },
    eases.cubicOut
  );
});

//
// TARIFF ITEM
//
// Animation
let stopTariffsItemsAnimation = [];

const handleTariffsItemsAnimation = () => {
  const tariffItems = document.querySelectorAll('.js-tariff-item');

  if (mediaSm.matches) {
    stopTariffsItemsAnimation.forEach((stop) => stop());
  } else {
    stopTariffsItemsAnimation = Array.from(tariffItems, (tariffItem) => {
      return scrollAnimationProgress(tariffItem, {
        getStart(el) {
          const rect = el.getBoundingClientRect();
          return rect.top + window.scrollY - window.innerHeight;
        },
        getEnd(el, start) {
          const height = el.offsetHeight;
          return start + height * 0.5;
        },
      });
    });
  }
};

handleTariffsItemsAnimation();
mediaSm.addEventListener('change', handleTariffsItemsAnimation);

//
// QUESTIONNAIRE
//
import questionnaireInit from '~scripts/blocks/questionnaire';

questionnaireInit();

//
// CUSTOMER FEEDBACKS
//
import customerFeedbacksInit from '~scripts/blocks/customer-feedbacks';

customerFeedbacksInit();

//
// CUSTOMER CASES
//
import customerCasesInit from '~scripts/blocks/customer-cases';

if (region !== 'ai') {
  customerCasesInit();
}

//
// API SUPERPOWER
//
import apiSuperpowerInit from '~scripts/blocks/api-superpower';

apiSuperpowerInit();

//
// FORMS
//
// Demo request
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});
